/**
 * Realtime envelope for shared-team + viewer-private live meeting insights.
 *
 * @module core/types/liveMeetingInsightsRealtime
 */

import type { LiveMeetingInsightsDtoV1 } from './liveMeetingInsights';

export const LIVE_MEETING_INSIGHTS_REALTIME_KIND = 'LIVE_MEETING_INSIGHTS_REALTIME_V1' as const;

export interface LiveMeetingInsightsRealtimeEnvelopeV1 {
  kind: typeof LIVE_MEETING_INSIGHTS_REALTIME_KIND;
  schemaVersion: 1;
  meetingId: string;
  serverTimestampMs: number;
  insights: LiveMeetingInsightsDtoV1;
}
